<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
   <div>
       <Breadcrumbs main="Attributes" title="Manage Attributes" />

      <div class="container-fluid">
         <div class="row">
            <div class="col-sm-12">
               <div class="card">
                  <div class="card-body">

                     <div class="col-md-12 project-list  page-subtitle">
                        <div class="row">
                           <div class="col-md-10 d-flex">
                              <span style="font-size: 20px; font-weight: bolder;">Manage Attributes</span>
                           </div>
                           <div class="col-md-2">
                              <router-link :to="{ name: 'addattribute' }" class="btn btn-primary">Add Attribute</router-link>
                              <!-- <div class="btn btn-primary">Add Attribute</div> -->
                           </div>                           
                        </div>
                     </div>

                     <div class="col-md-12 project-list  filter-sort">
                        <div class="row">
                           <div class="col-md-9 d-flex">
                              <label class="d-flex listing-length"><span>Show</span>
                                 <select class="form-select"  v-model="listing_length" @change="fetchAttributes()">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                 </select>
                                   <span>entries</span>
                              </label>
                           </div>
                              
                           <div class="col-md-3">
                                 <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchAttributes()"/>
                           </div>
                        </div>
                     </div>

                     <div class="table-responsive product-table">
                        <table class="display" id="basic-1">
                           <thead>
                              <tr>
                                 <th class="sorting_asc" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                    aria-sort="ascending" aria-label="Name: activate to sort column descending"
                                    style="width: 415.266px;">Name</th>
                                 <th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                    aria-label="Type: activate to sort column ascending"
                                    style="width: 337.797px;">Type</th>
                                 <th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                    aria-label="Status: activate to sort column ascending"
                                    style="width: 337.797px;">Status</th>
                                 <th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                    aria-label="Options: activate to sort column ascending"
                                    style="width: 415.266px;">Options</th>	
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="attribute in attributes" :key="attribute.id">
                                 
                                 <td>{{attribute.name}}</td>
                                 <td>{{attribute.type_name}}</td>
                                 <td>
                                    <label v-if="attribute.status==1">Active</label>
                                    <label v-else>Blocked</label>
                                 </td>
                                 <td>                                   
                                    <a variant="danger" class="btn btn-danger btn-sm mt-2 me-1" @click="deactivateAttribute(attribute)" v-if="attribute.status==1">Deactivate</a>
                                    <a variant="success" class="btn btn-success btn-sm mt-2 me-1" @click="activateAttribute(attribute)" v-else>Activate</a>

                                    <router-link :to="{name: 'attributes.show', params: { id: attribute.id }}" class="btn btn-sm btn-primary mt-2 me-1" >View</router-link>             
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>

                     <!----pagination starts --->
                     <nav aria-label="Page navigation" class="mt-2">                    
                        <ul class="pagination">
                           <li class="page-item" v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                              <a class="page-link" href="#" @click.prevent="fetchAttributes(page.url + '&limit='+ listing_length + '&keyword=' + keyword )" tabindex="-1">
                                 <span v-if="index == 0">Prev</span>
                                 <span v-else-if="index == pagination.length-1">Next</span>
                                 <span v-else>{{page.label}}</span>
                              </a>
                           </li>                        
                        </ul>
                     </nav>
                     <!----pagination ends --->

                  </div>
               </div>
            </div>
         </div>
      </div>


     
  </div>
</template>


<script>
export default {
   name:'ViewAttributes',
   data() {
      return {
         attributes: [],        
         pagination: {},
         edit: false,
         attribute_status: {
            id: "",
            status: ""
         },
         keyword: '',
         listing_length: 10,
         token: '',
         errors: {},
         activate: false,
         deactivate: false,
         active_page_url: null,
      };
   },
   mounted () {
      
   },

   created() {
      this.fetchAttributes();
   },

   methods: {      

      fetchAttributes(page_url=null) {
          let url = '/api/admin/attributes?limit=' + this.listing_length + '&keyword=' + this.keyword;
          page_url = page_url || url;   

          this.active_page_url = page_url;     
            
         this.getToken();
         this.$axios
            .get(page_url,{headers: {Authorization: 'Bearer ' + this.token,}})
            .then(res => {
               var responseData = res.data.data;
               this.attributes = responseData.data;  
               console.log(this.attributes);
               this.pagination = responseData.links
               
            })
            .catch(err => console.log(err));
      },    

      getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
            if(slo_admin.token) {
               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },

      
      activateAttribute(attribute) {
         this.activate = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to activate this attribute?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.attribute_status.id = attribute.id;
                  this.attribute_status.status = '1';
                  this.updateAttributeStatus();
					}
					
				});
      },
      deactivateAttribute(attribute) {
         this.deactivate = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to deactivate this attribute?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.attribute_status.id = attribute.id;
                  this.attribute_status.status = '0';
                  this.updateAttributeStatus();
					}
				});
      },
      updateAttributeStatus() {
         const config = {
              headers: {
                  'Authorization': 'Bearer ' + this.token,
              }
         };
         this.$axios
         .get('/api/admin/attributes/status?attribute_id=' + this.attribute_status.id + '&status=' + this.attribute_status.status, config)
         .then(response => {
               if(response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.fetchAttributes(this.active_page_url);
          })
          .catch(error => {
               if(error.response){
                  if(error.response.data.message){
                     this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
               
          });
      },
   }   
}
</script>